import {
  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILURE,
  CREATE_PRODUCT_RESET,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const createProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PRODUCT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: false,
        success: false,
        message: "",
      });

    case CREATE_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        success: true,
        error: false,
        message: (action.payload && action.payload.message) || "Product created successfully",
      });

    case CREATE_PRODUCT_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
        success: false,
        message: (action.payload && action.payload.error) || "Failed to create product",
      });

    case CREATE_PRODUCT_RESET:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};

export default createProductReducer;
